import { Head, Link } from '@inertiajs/react'
import MainLayout from '../../components/layout/MainLayout'
import Button from '../../components/ui/Button'

export default function NotFound() {
  return (
    <MainLayout>
      <Head title="Page non trouvée - 404" />

      <div className="min-h-[70vh] flex items-center justify-center bg-gradient-to-b from-primary-50 to-white px-4 py-20">
        <div className="text-center max-w-2xl">
          {/* Error Icon */}
          <div className="mb-8 inline-block">
            <svg className="w-32 h-32 mx-auto" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              {/* Cercle de fond */}
              <circle cx="12" cy="12" r="10" fill="#3B82F6" fillOpacity="0.1"/>

              {/* Point d'interrogation stylisé */}
              <path
                d="M12 17.5C11.5858 17.5 11.25 17.8358 11.25 18.25C11.25 18.6642 11.5858 19 12 19C12.4142 19 12.75 18.6642 12.75 18.25C12.75 17.8358 12.4142 17.5 12 17.5Z"
                fill="#3B82F6"
              />
              <path
                d="M12 5C10.067 5 8.5 6.567 8.5 8.5C8.5 8.91421 8.83579 9.25 9.25 9.25C9.66421 9.25 10 8.91421 10 8.5C10 7.39543 10.8954 6.5 12 6.5C13.1046 6.5 14 7.39543 14 8.5C14 9.30622 13.5978 10.0145 12.9844 10.4219C12.1817 10.9488 11.5 11.8221 11.5 13V14.5C11.5 14.9142 11.8358 15.25 12.25 15.25C12.6642 15.25 13 14.9142 13 14.5V13C13 12.4279 13.3183 12.0512 13.8906 11.7031C14.7772 11.1605 15.5 10.0188 15.5 8.5C15.5 6.567 13.933 5 12 5Z"
                fill="#3B82F6"
              />
            </svg>
          </div>

          {/* 404 */}
          <h1 className="text-8xl md:text-9xl font-bold text-primary-600 mb-4">
            404
          </h1>

          {/* Message */}
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Page non trouvée
          </h2>

          <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto">
            Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link href="/">
              <Button variant="primary" size="lg">
                Retour à l'accueil
              </Button>
            </Link>
            <Link href="/dashboard">
              <Button variant="outline" size="lg">
                Aller au dashboard
              </Button>
            </Link>
          </div>

          {/* Suggestions */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-500 mb-4">
              Pages populaires :
            </p>
            <div className="flex flex-wrap gap-3 justify-center">
              <Link href="/leads" className="text-sm text-primary-600 hover:text-primary-700 hover:underline">
                Leads
              </Link>
              <span className="text-gray-300">•</span>
              <Link href="/qr_codes" className="text-sm text-primary-600 hover:text-primary-700 hover:underline">
                QR Codes
              </Link>
              <span className="text-gray-300">•</span>
              <Link href="/properties" className="text-sm text-primary-600 hover:text-primary-700 hover:underline">
                Propriétés
              </Link>
              <span className="text-gray-300">•</span>
              <Link href="/tarifs" className="text-sm text-primary-600 hover:text-primary-700 hover:underline">
                Tarifs
              </Link>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  )
}
